'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Button = _interopDefault(require('@material-ui/core/Button'));
var ExpandMoreIcon = _interopDefault(require('@material-ui/icons/ExpandMore'));
var styledComponents = require('../styled-components.js');
var utils = require('../utils.js');

var ButtonWithAvatar = function (props) {
    var classes = styledComponents.useStyles();
    var onClick = props.onClick, name = props.name, ariaControls = props.ariaControls, hasPopUp = props.hasPopUp, src = props.src, nameElement = props.nameElement, _a = props.iconSize, iconSize = _a === void 0 ? '1.6em' : _a, buttonStyle = props.buttonStyle;
    var avatar = utils.getAvatar(src, name, classes);
    return (React__default.createElement(Button, { "aria-controls": ariaControls, "aria-haspopup": hasPopUp, startIcon: avatar, style: styledComponents.buttonOverrides(buttonStyle), variant: 'contained', color: 'primary', onClick: onClick, endIcon: React__default.createElement(ExpandMoreIcon, { className: classes.expandIcon, style: { fontSize: iconSize } }) }, nameElement || name));
};

module.exports = ButtonWithAvatar;
